<template>
  <v-dialog v-model="show" persistent max-width="600px" max-height="600px">
    <v-card :loading="loading" :disabled="loading">
      <v-form ref="form" @submit.prevent="sendSMS">
        <v-card-title>
          <span class="headline">{{ $t('sendPlayerByMail.title') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <label for="phone">{{ $t('sendPlayerBySMS.phoneLabel') }}</label>
                <v-text-field
                  ref="mobile"
                  v-model="phoneValue"
                  :rules="[mobileRules]"
                  name="phone"
                  type="tel"
                  id="phone"
                  @input="checkPhoneValidation"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea v-model="text" :rules="[textAreaRules]" auto-grow counter></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" text @click="show = false">{{ $t('sendPlayerByMail.cancel') }}</v-btn>
          <v-btn color="primary" text type="submit">{{ $t('sendPlayerByMail.send') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

export default {
  name: 'SendMessageByPhone',

  props: {
    value: Boolean,
    username: {
      type: String,
      default: ''
    },
    userEmail: {
      type: String,
      default: ''
    },
    initialText: {
      type: String,
      default: ''
    },
    shootingType: {
      type: String
    },
    marketplaceProductRef: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    phoneValue: '',
    phone: {
      number: '',
      valid: false,
      country: ''
    },
    loading: false,
    text: ''
  }),

  computed: {
    ...mapGetters(['userId']),
    show: {
      get() {
        if (this.value) {
          this.initForm()
        }
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    textAreaRules(v) {
      if (!v) return this.$t('sendPlayerBySMS.required')
      else if (v.length > 160) return this.$t('sendPlayerBySMS.maxLength')
      else return true
    },
    mobileRules(v) {
      if (!v) return this.$t('sendPlayerBySMS.required')
      else if (!this.phone.valid) return this.$t('sendPlayerBySMS.phoneFormat')
      else return true
    },
    checkPhoneValidation() {
      this.phone.number = window.iti.getNumber()
      this.phone.valid = window.iti.isValidNumber()
    },
    initForm() {
      this.text = this.initialText
      this.phoneValue = ''
      this.show = true
    },
    replaceCarriage(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '\n')
    },
    async sharedSMSStatistics() {
      return await this.$store.dispatch('sharedPlayerStatistics', {
        userId: this.userId,
        marketplaceProductRef: this.marketplaceProductRef,
        data: {
          source: 'WEB',
          sharingType: 'SMS'
        }
      })
    },
    async sendSMS() {
      if (this.$refs.form.validate() && this.phone.valid) {
        this.loading = true
        let data = {}

        data.to = this.phone.number.replace(/\s/g, '').replace('/-/g', '')
        data.body = this.replaceCarriage(this.text)

        const res = await this.$store.dispatch('sendSms', data)

        if (res) {
          if (this.shootingType === 'VIDEO') {
            this.sharedSMSStatistics()
          }
          this.show = false
          this.$refs.form.reset()
        }

        this.loading = false
      }
    }
  },
  watch: {
    show(v) {
      if (v) {
        setTimeout(() => {
          const input = document.getElementById('phone')

          var iti = intlTelInput(input, {
            initialCountry: 'FR',
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/8.5.0/js/utils.js'
          })

          input.addEventListener('countrychange', () => {
            this.phoneValue = ''
            input.value = ''
          })

          window.iti = iti
        }, 250)
      } else {
        window.iti.destroy()
      }
    }
  }
}
</script>

<style>
.iti__country-name {
  color: rgb(75, 75, 75) !important;
}
</style>
